import React from 'react';
import Donut from '../../../components/Donut/Donut';


const DienstverbandWerknemers = () => {

	const dataVerpleging = [
			{
	        "label": "Vast contract",
	        "value": 83,
	    },
			{
	        "label": "Flex contract",
	        "value": 17,
	    }
	];

	const dataThuiszorg = [
			{
	        "label": "Vast contract",
	        "value": 78,
	    },
			{
	        "label": "Flex contract",
	        "value": 22,
	    }
	];

	const formatLabel = item => item.label + ': ' + item.percentage + '%';

	const formatTotalVerpleging = () => (
		<text textAnchor="middle" fontFamily="din-regular">
      <tspan x={0} dy={-15}>237.000</tspan>
      <tspan x={0} dy={15}>verplegenden &</tspan>
       <tspan x={0} dy={15}>verzorgenden</tspan>
    </text>);


	const formatTotalThuiszorg = () => (
		<text textAnchor="middle" fontFamily="din-regular">
      <tspan x={0} dy={-15}>130.000</tspan>
      <tspan x={0} dy={15}>thuiszorg-</tspan>
       <tspan x={0} dy={15}>medewerkers</tspan>
    </text>);




	return (
		<div className="vis-dienstverband-werknemers">

			<Donut
				data={dataVerpleging}
				height={400}
				fontFamily="din-regular"
				fontSize="15px"
				formatLabel={formatLabel}
				formatTotal={formatTotalVerpleging}
				unit="procent"
				animation={true}
			/>

			<Donut
				data={dataThuiszorg}
				height={400}
				fontFamily="din-regular"
				fontSize="15px"
				formatLabel={formatLabel}
				formatTotal={formatTotalThuiszorg}
				unit="procent"
				animation={true}
			/>

			<div className="vis-credit">
				<p>Aantal zorgprofessionals in 2016 naar werkzaamheden en type dienstverband</p>
				<p>Bron: AZWinfo 2017</p>
			</div>

		</div>
	);
}

export default DienstverbandWerknemers;


